import { render, staticRenderFns } from "./vodne-stavy.vue?vue&type=template&id=197ada40&"
import script from "./vodne-stavy.vue?vue&type=script&lang=js&"
export * from "./vodne-stavy.vue?vue&type=script&lang=js&"
import style0 from "./vodne-stavy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports